import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@shared/hooks/useAuth';
import { adminRoutes, publicRoutes } from '@config/routes';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Kiểm tra đường dẫn hiện tại để quyết định redirect đến đâu
    // Nếu đang ở route admin (/admin/*) thì redirect đến admin login
    // Nếu không thì redirect đến public login
    const isAdminRoute = location.pathname.startsWith('/admin/');
    const loginRoute = isAdminRoute ? adminRoutes.login : publicRoutes.login;
    return <Navigate to={loginRoute} replace />;
  }

  return <>{children}</>;
}

